import { Link } from 'react-router-dom';
import { clientInitials, clients, type Client } from '@/content/clients';

/** Logo do cliente, ou a inicial da empresa enquanto o arquivo não chega. */
export function ClientLogo({ client, size }: { client: Client; size?: number }) {
  const style = size ? { width: size, height: size } : undefined;
  if (client.logo) {
    return (
      <img
        className="hx-logo"
        src={client.logo}
        alt={`Logo de ${client.name}`}
        width={64}
        height={64}
        loading="lazy"
        decoding="async"
        style={style}
      />
    );
  }
  return (
    <span className="hx-logo" aria-hidden style={style}>
      {clientInitials(client.name)}
    </span>
  );
}

function ClientCard({ client, hidden }: { client: Client; hidden?: boolean }) {
  const body = (
    <>
      <ClientLogo client={client} />
      <span className="hx-client-txt">
        <strong>{client.name}</strong>
        {client.segment && <span>{client.segment}</span>}
      </span>
    </>
  );
  if (client.href) {
    return (
      <Link className="hx-client" to={client.href} tabIndex={hidden ? -1 : undefined}>
        {body}
      </Link>
    );
  }
  return <div className="hx-client">{body}</div>;
}

/** Faixa animada logo abaixo do hero. A segunda cópia só existe para o loop. */
export function ClientsStrip() {
  return (
    <section className="hx-clients" aria-label="Clientes da Operax">
      <div className="hx-clients-head">
        <span className="hx-label">Empresas que já operam com a Operax</span>
        <Link className="hx-link" to="/clientes">
          Ver resultados reais →
        </Link>
      </div>
      <div className="hx-marquee">
        <div className="hx-marquee-track">
          <div style={{ display: 'flex' }}>
            {clients.map((c) => (
              <ClientCard key={c.slug} client={c} />
            ))}
          </div>
          <div style={{ display: 'flex' }} aria-hidden="true">
            {clients.map((c) => (
              <ClientCard key={c.slug} client={c} hidden />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
